<template>
  <div class="field">
    <label class="label" for="operateur">Opérateur :</label>
    <select class="select" v-model="ordreFabrication.operateur" id="operateur">
      <option v-for="utilisateur in utilisateurs" :key="utilisateur.id" :value="utilisateur.id">
        {{ utilisateur.prenom }} {{ utilisateur.nom }}
      </option>
    </select>
  </div>

  <div class="field">
    <label class="label" for="equipement">Equipement :</label>
    <select class="select" v-model="ordreFabrication.equipement" id="equipement">
      <option
        v-for="equipement in equipements.filter((item) => item.actif)"
        :key="equipement.id"
        :value="equipement.id"
      >
        {{ equipement.nom }}
      </option>
    </select>
  </div>

  <div class="field">
    <label class="label" for="client">Client :</label>
    <select class="select" v-model="ordreFabrication.client" id="client">
      <option
        v-for="client in clients.filter((item) => item.actif)"
        :key="client.id"
        :value="client.id"
      >
        {{ client.raison_sociale }}
      </option>
    </select>
  </div>

  <div class="field">
    <label class="label" for="client">Date :</label>
    <input type="date" class="input" required v-model="ordreFabrication.date_creation" />
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, type Ref } from 'vue'
import type EquipementList from '@/interfaces/Equipement.ts'
import type ClientList from '@/interfaces/Client.ts'
import type UtilisateurList from '@/interfaces/Utilisateur.ts'
import type { OrdreFabricationGet } from '@/interfaces/OrdreFabrication.ts'
import { useCacheStore } from '@/stores/cache.ts'

// modèle
const ordreFabrication = defineModel<OrdreFabricationGet>({ required: true })

// caches
const cacheStore = useCacheStore()

const equipements: Ref<EquipementList[]> = ref([])
const clients: Ref<ClientList[]> = ref([])
const utilisateurs: Ref<UtilisateurList[]> = ref([])

async function getEquipements() {
  equipements.value = await cacheStore.getEquipements()
}
async function getClients() {
  clients.value = await cacheStore.getClients()
}
async function getUtilisateurs() {
  utilisateurs.value = await cacheStore.getUtilisateurs()
}
onMounted(async () => {
  await getEquipements()
  await getClients()
  await getUtilisateurs()
})
</script>
